import { useHotkeys, type Options } from "react-hotkeys-hook";

/**
 * Thin wrapper around react-hotkeys-hook's `useHotkeys`.
 * Centralises default options so every shortcut in the app behaves
 * consistently: enabled in inputs is off by default, preventDefault is on.
 */
export function useGlobalShortcut(
  keys: string,
  callback: (event: KeyboardEvent) => void,
  options?: Options,
) {
  return useHotkeys(keys, callback, {
    preventDefault: true,
    enableOnFormTags: false,
    ...options,
  });
}
